import { render, staticRenderFns } from "./AllergiesCard.vue?vue&type=template&id=14b8bb92&scoped=true"
import script from "./AllergiesCard.vue?vue&type=script&lang=js"
export * from "./AllergiesCard.vue?vue&type=script&lang=js"
import style0 from "./AllergiesCard.vue?vue&type=style&index=0&id=14b8bb92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b8bb92",
  null
  
)

export default component.exports